import { render } from "./batch_mianshi.vue?vue&type=template&id=68dd386b&scoped=true"
import script from "./batch_mianshi.vue?vue&type=script&lang=js"
export * from "./batch_mianshi.vue?vue&type=script&lang=js"

import "./batch_mianshi.vue?vue&type=style&index=0&id=68dd386b&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68dd386b"]])

export default __exports__